import React, { Component } from "react";
import TldrBase from "../TldrLogin/TldrBase";
import { Link } from "react-router-dom";
import { ROOT } from "../_utils/routes";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FaArrowLeft } from "react-icons/fa";
import { withTranslation } from "react-i18next";
import { Box, Icon } from "@chakra-ui/react";

class Tldr403 extends Component {
  render() {
    const { t } = this.props;
    const { isAuthenticated, payload } = this.props.auth;

    return (
      <TldrBase heading={"Access denied!"} subheading={t("errors.no_access")}>
        <Box className="secondary-links" textAlign="center" mt={4}>
          <Link to={ROOT}>
            <Icon as={FaArrowLeft} mr={1} />
            {t("back_to_login")}
          </Link>
        </Box>
        {isAuthenticated && (
          <>
            <hr className="tldr-hl"></hr>
            <Box className="copyright" textAlign="center" mt={4}>
              {t("user_login_detail", { email: payload?.user?.email })}
            </Box>
          </>
        )}
      </TldrBase>
    );
  }
}

Tldr403.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(Tldr403)
);
